export default __webpack_public_path__ + "static/media/visual.0f014932.png";